import { PartialSubset } from '@upr-web-primer/app-utils';
import { merge } from 'lodash-es';
import { ush_shared_environment } from './ush.shared';

const overwrite: PartialSubset<typeof ush_shared_environment> = {
  production: true,
};
export const environment = merge(ush_shared_environment, overwrite);
